export const FeatureNotEnabledText = "This feature not enabled.";
export const DataSubmittedSuccessfullyText = "Data submitted successfully.";
export const ErrorOccurredText = "Error occurred.";
export const SessionExpiredText = "Your session has expired. Please relogin.";
export const SomethingWentWrongText = "Something went wrong, please try again.";
export const FileExtensionDoesntMatchText =
  "File extension does not match actual format.";
export const UploadInvalidFileTypeText =
  "Invalid file type. Only jpeg, jpg, png, bmp, gif, pdf, heic are accepted.";
export const FileSizeTooLargeText =
  "File size too large. Required file size less than 20MB.";
export const FileSizeTooSmallText =
  "File size too small. Required file size greater than 1KB.";
export const AcceptsOneFileText = "Accepts only 1 file at a time.";
export const ErrorInDealerCommitUploadText =
  "Error occurred in dealer commitment while uploading the document.";
export const ErrorInStipDocUploadText =
  "Error occurred in stip document uploader while uploading the document.";
export const UnableToCaptureFileNameText =
  "Unable to capture the file name from the upload controller.";
export const DealerInvalidFileTypeText =
  "Invalid file type. Only jpeg, jpg, png are accepted.";
export const NoDataFoundText = "No data found.";
export const EnterValidUserIdText = "Enter valid user id.";
export const EnterValidPageNoText = "Enter valid page number.";
export const ResetPassSuccessText =
  "If there is an account associate with that email address, we will email you a link to reset your password. Make sure to check your spam.";
export const InvalidEmailText = "Invalid email address.";
export const OTPSentSuccessText = "OTP sent successfully.";
export const OTPErrorOccurredText =
  "Error occurred, while sending OTP. Please try again.";
export const InvalidOTPText = "Invalid OTP.";
export const OTPExpiredText = "OTP expired.";
export const RegisteredLandlineText =
  "This is registered as a landline, Please provide a mobile number.";
export const CreatePasswordSuccessText = "Password created successfully.";
export const UpdatePasswordSuccessText = "Password updated successfully.";
export const UnableToAccessText = "Unable to access.";
export const LoanDetailsNotFoundText = "Loan details not found.";
export const SelectOneAULRatesText = "Select atleast 1 AUL rates.";
export const NoRehashFoundText = "No rehash found.";
export const NoAULRatesFoundText = "No AUL rates found.";
export const DealerAvatarFileSize =
  "File size too large. Required file size less than 2MB.";
export const CustomerInfoIdNotFoundText =
  "Customer Info not found. Please refresh the page.";
export const FailedPrevUpdDocText =
  "Failed to load previously uploaded document.";
export const InvalidInvitationLinkText =
  "Invalid invitation link. Please check your email for the correct link.";
export const InvalidVerificationCodeText =
  "Invalid verification code. Please try again.";
export const VerificationFailedText = "Verification failed. Please try again.";
export const VerificationCodeSentText =
  "A new verification code has been sent to your email.";
export const TooManyRequestsText =
  "Too many requests. Please wait a moment before trying again.";
export const AuthorizationAgreementText =
  "Please agree to the authorization to contact customer and references.";
